import { useMemo } from 'react'
import { itemHistoryProcess } from 'src/lib/itemHistory'

export const useExpiryHistoryItem = (itemsHistory) => {
  return useMemo(() => {
    return itemHistoryProcess(itemsHistory)
  }, [itemsHistory])
}
